import { useCallback } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useOperatorInstitutionSwitch } from './useOperatorInstitutionSwitch';
import { useAppSelector } from '../redux/hooks';
import { useGetOperatorContextQuery } from '../redux/institutionAdmin';
import { PLATFORM_OPERATOR_CONTEXT, selectIsPlatformContext } from '../redux/operatorContext';

export type PlatformMode = Readonly<{
  /** Whether the caller may enter platform mode. Answered by the api, so a read that has not
   * landed or failed offers nothing. */
  available: boolean;
  /** Whether the requests this tab sends carry platform mode. */
  active: boolean;
  enter: () => void;
}>;

export const usePlatformMode = ({ enabled }: Readonly<{ enabled: boolean }>): PlatformMode => {
  const context = useGetOperatorContextQuery(enabled ? undefined : skipToken);
  const active = useAppSelector(selectIsPlatformContext);
  const switchOperatorContext = useOperatorInstitutionSwitch();

  const enter = useCallback(
    () => switchOperatorContext(PLATFORM_OPERATOR_CONTEXT),
    [switchOperatorContext],
  );

  return {
    available: context.data?.platformAvailable ?? false,
    active,
    enter,
  };
};
